import { useState } from 'react';
import { Modal } from './Modal';
import { Avatar } from '../lib/helpers';

const GROUP_COLORS = ['#1D9E75','#378ADD','#7F77DD','#D85A30','#BA7517','#D4537E'];

export function AddGroupModal({ people, onSave, onClose }) {
  const [name, setName] = useState('');
  const [color, setColor] = useState(GROUP_COLORS[0]);
  const [selected, setSelected] = useState(people.filter(p => p.name === 'You').map(p => p.id));
  const [saving, setSaving] = useState(false);

  const toggle = (id) => {
    const you = people.find(p => p.name === 'You');
    if (you && id === you.id) return; // can't deselect yourself
    setSelected(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id]);
  };

  const submit = async () => {
    if (!name.trim()) { alert('Enter a group name'); return; }
    if (selected.length < 2) { alert('Add at least 2 members'); return; }
    setSaving(true);
    try {
      await onSave({ name: name.trim(), color, members: selected });
      onClose();
    } catch (e) { alert(e.message); }
    setSaving(false);
  };

  return (
    <Modal title="New group" onClose={onClose}>
      <div className="form-group">
        <label className="form-label">Group name</label>
        <input className="form-input" value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Weekend Trip" />
      </div>
      <div className="form-group">
        <label className="form-label">Color</label>
        <div style={{ display: 'flex', gap: 8 }}>
          {GROUP_COLORS.map(c => (
            <button key={c} onClick={() => setColor(c)} style={{
              width: 28, height: 28, borderRadius: '50%', background: c, border: color === c ? '3px solid var(--text)' : '3px solid transparent',
              cursor: 'pointer'
            }} />
          ))}
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">Members</label>
        {people.map(p => {
          const isYou = p.name === 'You';
          const checked = selected.includes(p.id);
          return (
            <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 0', cursor: isYou ? 'default' : 'pointer', fontSize: 14 }}>
              <input type="checkbox" checked={checked} onChange={() => toggle(p.id)} disabled={isYou} />
              <Avatar person={p} />
              {p.name}{isYou ? ' (you)' : ''}
            </label>
          );
        })}
      </div>
      <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: 9 }} onClick={submit} disabled={saving}>
        {saving ? 'Creating…' : 'Create group'}
      </button>
    </Modal>
  );
}
